import { render, staticRenderFns } from "./ResultActivate.vue?vue&type=template&id=7149b9ee&"
import script from "./ResultActivate.vue?vue&type=script&lang=js&"
export * from "./ResultActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports